import { Stack } from '@mantine/core';
import classNames from 'classnames/bind';
import { PageTitle, Panel } from 'components/index';
import { useCompanyConfiguration } from 'init/use-company-configuration';
import { i18nKeys, useTranslation } from 'locales';
import { useEffect } from 'react';
import type { RouteChildrenProps } from 'react-router';
import { accountActions } from 'store/account/account.actions';

import { INTEGRATIONS_ROUTE, Integration } from '../../Integrations.constants';
import { INTEGRATION_UPDATE_CALLBACK, IntegrationFormFieldsName } from '../Integration.constants';
import styleIdentifiers from '../Integration.module.scss';
import { useGetIntegrationRights } from '../Integration.utils';
import { IntegrationHeader } from '../IntegrationHeader';
import {
  TeamleaderForm,
  type TeamleaderFormFields,
  TeamleaderFormFieldsName,
} from './TeamleaderForm';

const styles = classNames.bind(styleIdentifiers);

export const Teamleader = ({ history: { replace } }: RouteChildrenProps) => {
  const { t } = useTranslation();

  const company = useCompanyConfiguration();
  const getIntegrationRights = useGetIntegrationRights();

  const { isActive, canActivate } = getIntegrationRights(Integration.TEAMLEADER);

  useEffect(() => {
    if (!canActivate && !isActive) {
      replace(INTEGRATIONS_ROUTE);
    }
  }, [canActivate, isActive, replace]);

  const handleSubmit = (data: TeamleaderFormFields) => {
    accountActions.updateTeamleaderSettings({
      data,
      callback: INTEGRATION_UPDATE_CALLBACK,
    });
  };

  if (!company?.tp_accounting) {
    return (
      <div className={styles('loading')}>
        <div>{t(i18nKeys.LOADING)}</div>
      </div>
    );
  }

  const {
    tp_accounting: {
      use_import,
      issue_date_limit,
      automatic_sync,
      use_payment_matching,
      use_payment_export,
      debtor_update,
    },
  } = company;

  return (
    <>
      <PageTitle>
        <PageTitle.Back />
        {Integration.TEAMLEADER}
        <PageTitle.Actions>
          <IntegrationHeader name={Integration.TEAMLEADER} />
        </PageTitle.Actions>
      </PageTitle>
      <Stack>
        <Panel>
          <TeamleaderForm
            onSubmit={handleSubmit}
            initialValues={{
              [TeamleaderFormFieldsName.IMPORT_INTEGRATION]: use_import,
              [TeamleaderFormFieldsName.PAYMENT_MATCHING]: use_payment_matching,
              [TeamleaderFormFieldsName.PAYMENT_EXPORT]: use_payment_export,
              [IntegrationFormFieldsName.ISSUE_DATE_LIMIT]: issue_date_limit,
              [IntegrationFormFieldsName.DEBTOR_UPDATE]: debtor_update,
              [IntegrationFormFieldsName.AUTOMATIC_SYNC]: automatic_sync,
            }}
          />
        </Panel>
      </Stack>
    </>
  );
};
